export const Purchases = {
  SUBSIDY: 'subsidy',
  COSMOS: 'cosmos',
  FIRST_BILL: 'firstBill',
  CURRENCY: 'RSD',
};
